import React from "react";

const ScrollTop = () => {
	return (
		<div className="scroll-top">
			<a className="smoothscroll" href="#top">
				<i className="flaticon-go-up-in-web"></i>
			</a>
		</div>
	);
};
export default ScrollTop;
